import { render, staticRenderFns } from "./CampaignStatsTable.vue?vue&type=template&id=25016668&scoped=true&"
import script from "./CampaignStatsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatsTable.vue?vue&type=style&index=0&id=25016668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25016668",
  null
  
)

export default component.exports